// extracted by mini-css-extract-plugin
export default {"container":"home_container__4DGNK","text":"home_text__XpP6t","image":"home_image__N-e9Y"};